import { render, staticRenderFns } from "./AdminCustomerIdsExplainer.vue?vue&type=template&id=513699f8&scoped=true&"
import script from "./AdminCustomerIdsExplainer.vue?vue&type=script&lang=ts&"
export * from "./AdminCustomerIdsExplainer.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCustomerIdsExplainer.vue?vue&type=style&index=0&id=513699f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513699f8",
  null
  
)

export default component.exports